import React, { useState } from "react";
import {
  Grid,
  Table,
  TableHeaderRow,
  PagingPanel,
  SearchPanel,
  Toolbar,
  TableRowDetail,
} from "@devexpress/dx-react-grid-material-ui";
import {
  PagingState,
  SearchState,
  IntegratedPaging,
  IntegratedFiltering,
  RowDetailState,
} from "@devexpress/dx-react-grid";
import AppBar from "@material-ui/core/AppBar";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Typography from "@material-ui/core/Typography";
import { CircularProgress, withStyles } from "@material-ui/core";
import PropTypes from "prop-types";
import {
  GET_MY_DEALERS_SALE,
  PAST_BOAT_SHOW,
  UPCOMING_BOAT_SHOW,
} from "../queries";
import "./salesBoatShowTab.scss";
import { useQuery, useSubscription } from "@apollo/client";
import auth from "Auth";

const styles = (theme) => ({
  button: {
    margin: theme.spacing(),
  },
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
  },
  textField: {
    marginLeft: theme.spacing(),
    marginRight: theme.spacing(),
    width: 275,
  },
  navBar: {
    display: "flex",
    flexWrap: "no-wrap",
  },
  paper: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: theme.spacing(2),
    padding: "30px",
    "&:focus-visible": {
      outline: "transparent",
    },
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-evenly",
    width: "100%",
    marginTop: theme.spacing(2),
  },
});

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

const RowDetail = ({ row }) => (
  <div>
    <table cellSpacing="0" className="detailTable">
      <tbody>
        <tr>
          <td>Visible On:</td>
          <td>{row?.site}</td>
        </tr>
        <tr>
          <td>Dealer:</td>
          <td>{row?.dealer}</td>
        </tr>
        <tr>
          <td>Name:</td>
          <td>{row?.name}</td>
        </tr>
        <tr>
          <td>Address:</td>
          <td>{row?.address}</td>
        </tr>
        <tr>
          <td>Region:</td>
          <td>{row?.region}</td>
        </tr>
        <tr>
          <td>Brands:</td>
          <td>{row?.brands}</td>
        </tr>
        <tr>
          <td>Start Date:</td>
          <td>{row?.start_date}</td>
        </tr>
        <tr>
          <td>End Date:</td>
          <td>{row?.end_date}</td>
        </tr>
      </tbody>
    </table>
  </div>
);

const BoatShowTabs = ({ classes }) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [selectedField, setSelectedField] = useState("Boat Show Name");
  const [searchValueUpComing, setSearchValueUpComing] = useState("");
  const [selectedFieldUpComing, setSelectedFieldUpcoming] =
    useState("Boat Show Name");
  const columns = [
    { name: "name", title: "Boat Show Name" },
    { name: "dealer", title: "Dealer" },
    { name: "address", title: "Address" },
    { name: "start_date", title: "Start Date" },
  ];

  const { data: salesData, loading } = useQuery(GET_MY_DEALERS_SALE, {
    notifyOnNetworkStatusChange: true,
    variables: { profile_id: auth.getSub() },
    fetchPolicy: "cache-and-network",
  });

  const {
    data: upComingBoat,
    loading: upComingLoading,
    error,
  } = useSubscription(UPCOMING_BOAT_SHOW, {
    notifyOnNetworkStatusChange: true,
    skip: salesData === undefined,
    variables: {
      profileIds: [
        ...(salesData?.sales_assign?.map((e) => e?.assign_user_id) || []),
        auth.getSub(),
      ],
    },
    fetchPolicy: "cache-and-network",
  });

  const { data: pastBoat, loading: pastLoading } = useSubscription(
    PAST_BOAT_SHOW,
    {
      notifyOnNetworkStatusChange: true,
      skip: salesData === undefined,
      variables: {
        profileIds: [
          ...(salesData?.sales_assign?.map((e) => e?.assign_user_id) || []),
          auth.getSub(),
        ],
      },
      fetchPolicy: "cache-and-network",
    }
  );

  const changeSearchValue = (newValue) => {
    setSearchValue(newValue);
  };

  const changeSearchValueUpcoming = (newValue) => {
    setSearchValueUpComing(newValue);
  };

  const handleTabChange = (event, value) => {
    setActiveTabIndex(value);
  };

  const FieldDropdown = ({ fields, selectedField, onSelectField }) => (
    <select
      value={selectedField}
      onChange={(e) => onSelectField(e.target.value)}
    >
      {fields?.map((field) => (
        <option key={field} value={field}>
          {field}
        </option>
      ))}
    </select>
  );

  const handleFieldChange = (selectedField) => {
    console.log(selectedField, "test");
    setSelectedField(selectedField);
    setSearchValue(""); // Reset search value when field changes
  };

  const handleFieldChangeUpComing = (selectedField) => {
    setSelectedFieldUpcoming(selectedField);
    setSearchValueUpComing(""); // Reset search value when field changes
  };

  const FieldDropdownUpComing = ({ fields, selectedField, onSelectField }) => (
    <select
      value={selectedField}
      onChange={(e) => onSelectField(e.target.value)}
    >
      {fields?.map((field) => (
        <option key={field} value={field}>
          {field}
        </option>
      ))}
    </select>
  );

  const handleDealerChange = (event) => {
    setSearchValue(event.target.value);
  };

  const handleDealerChangeUpComing = (event) => {
    setSearchValueUpComing(event.target.value);
  };

  const uniqueDealersPast = [
    ...new Set(pastBoat?.boat_shows?.map((row) => row?.dealer).filter(Boolean)),
  ];

  const uniqueDealersUpcoming = [
    ...new Set(upComingBoat?.boat_shows?.map((row) => row?.dealer)),
  ];

  const filteredRowsPast = pastBoat?.boat_shows?.filter((row) => {
    if (selectedField === "Dealer") {
      if (!searchValue) return true; // Show all if no dealer is selected
      return (
        row?.dealer?.toString().trim().toLowerCase() ===
        searchValue?.trim().toLowerCase()
      );
    }
    let name =
      row?.[
        columns.find((e) => e?.title === selectedField)?.name
      ]?.toLowerCase();
    return name?.includes(searchValue?.toLowerCase().trim());
  });

  const filteredRowsUpcoming = upComingBoat?.boat_shows?.filter((row) => {
    if (selectedFieldUpComing === "Dealer") {
      if (!searchValueUpComing) return true; // Show all rows if no dealer is selected
      return (
        row?.dealer?.toString().trim().toLowerCase() ===
        searchValueUpComing?.trim().toLowerCase()
      );
    }

    let name =
      row?.[
        columns.find((e) => e?.title === selectedFieldUpComing)?.name
      ]?.toLowerCase();
    return name?.includes(searchValueUpComing?.toLowerCase().trim());
  });

  return (
    <div>
      <div className={classes.root + " tableStyles"}>
        <AppBar position="static">
          <Tabs value={activeTabIndex} onChange={handleTabChange}>
            <Tab label="Upcoming" />
            <Tab label="Past" />
          </Tabs>
        </AppBar>
        {loading ? (
          <CircularProgress />
        ) : (
          <>
            {activeTabIndex === 0 && (
              <TabContainer className="salesboat-upcoming-pg">
                {loading || upComingLoading ? (
                  <CircularProgress />
                ) : (
                  <>
                    {upComingBoat && (
                      <Grid rows={filteredRowsUpcoming || []} columns={columns}>
                        <SearchState
                          value={searchValueUpComing}
                          onValueChange={changeSearchValueUpcoming}
                        />
                        <PagingState defaultCurrentPage={0} pageSize={10} />
                        <IntegratedFiltering />
                        <IntegratedPaging />
                        <RowDetailState defaultExpandedRowIds={[0]} />
                        <Table />
                        <TableHeaderRow />
                        <PagingPanel />
        ~                <TableRowDetail contentComponent={RowDetail} />
                        <Toolbar />
                        <div
                          style={
                            selectedFieldUpComing === "Dealer"
                              ? { position: "inherit" }
                              : {}
                          }
                          className={`tableFilter `}
                        >
                          {/* {console.log("Selected Field:", selectedFieldUpComing)} */}
                          <div className="wrapper">
                            <FieldDropdownUpComing
                              fields={columns?.map((column) => column?.title)}
                              selectedField={selectedFieldUpComing}
                              onSelectField={(val) =>
                                handleFieldChangeUpComing(val)
                              }
                            />
                            {selectedFieldUpComing === "Dealer" ? (
                              <select
                                value={searchValueUpComing}
                                onChange={handleDealerChangeUpComing}
                                style={{margin: '0 20px'}}
                              >
                                <option value="">Select Dealer</option>
                                {uniqueDealersUpcoming.map((dealer) => (
                                  <option key={dealer} value={dealer}>
                                    {dealer}
                                  </option>
                                ))}
                              </select>
                            ) : (
                              <SearchPanel />
                            )}
                          </div>
                        </div>
                      </Grid>
                    )}
                  </>
                )}
              </TabContainer>
            )}
            {activeTabIndex === 1 && (
              <TabContainer>
                {loading || pastLoading ? (
                  <CircularProgress />
                ) : (
                  <>
                    {pastBoat && (
                      <Grid rows={filteredRowsPast || []} columns={columns}>
                        <SearchState
                          value={searchValue}
                          onValueChange={changeSearchValue}
                        />
                        <PagingState defaultCurrentPage={0} pageSize={10} />
                        <IntegratedFiltering />
                        <IntegratedPaging />
                        <RowDetailState defaultExpandedRowIds={[0]} />
                        <Table />
                        <TableHeaderRow />
                        <PagingPanel />
                        <TableRowDetail contentComponent={RowDetail} />
                        <Toolbar />
                        <div
                          style={
                            selectedField === "Dealer"
                              ? { position: "inherit" }
                              : {}
                          }
                          className={`tableFilter `}
                        >
                          {console.log("Selected Field:", selectedField)}
                          <div className="wrapper">
                            <FieldDropdown
                              fields={columns?.map((column) => column?.title)}
                              selectedField={selectedField}
                              onSelectField={(val) => handleFieldChange(val)}
                            />
                            {selectedField === "Dealer" ? (
                              <select
                                value={searchValue || ""}
                                onChange={handleDealerChange}
                                style={{margin: '0 20px'}}
                              >
                                <option value="">Select Dealer</option>
                                {uniqueDealersPast.map((dealer) => (
                                  <option key={dealer} value={dealer}>
                                    {dealer}
                                  </option>
                                ))}
                              </select>
                            ) : (
                              <SearchPanel />
                            )}
                          </div>
                        </div>
                      </Grid>
                    )}
                  </>
                )}
              </TabContainer>
            )}
          </>
        )}
      </div>
    </div>
  );
};

BoatShowTabs.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(BoatShowTabs);
